import { render } from "./Page404.vue?vue&type=template&id=3e46e7a0"
const script = {}

import exportComponent from "/home/jenkins/agent/workspace/sd-app-pipe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__